module.exports = __webpack_public_path__ + "img/setting3.68ebbfa0.png";